import { useEffect, useRef, useState } from 'react'
import { useRafLoop } from 'react-use'
import { Range } from 'types'

const useLoopTime = (duration: number, paused: boolean = false, timing?: Range): [number, (time: number) => void] => {
    const timeRef = useRef<number>(Date.now())
    const [time, setTime] = useState<number>(0)

    const [stopLoop, startLoop] = useRafLoop(() => {
        const now = Date.now()
        const diff = now - timeRef.current

        setTime((currentTime) => {
            const minTime = timing?.start || 0
            const maxTime = timing?.end || duration
            const newTime = (currentTime + diff / 1000) % maxTime

            return Math.max(minTime, Math.min(maxTime, newTime))
        })

        timeRef.current = now
    })

    useEffect(() => {
        if (paused) {
            stopLoop()
        } else {
            timeRef.current = Date.now()
            startLoop()
        }
    }, [paused])

    return [time, setTime]
}

export default useLoopTime
